import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { IconButton } from '@leroy-merlin-br/backyard-react-ui'

const baseStyles = ({ theme }) => css`
  label: breadcrumb-bar;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${theme.colors.background};

  position: sticky;
  top: 0;

  transition: 0.32s ease-in-out;

  z-index: 11;

  ${theme.media.giga} {
    background-color: transparent;
    position: relative;
    justify-content: center;
    z-index: 1;
  }
`

export const BreadcrumbBar = styled('div')(baseStyles)

const wrapperStyles = ({ theme }) => css`
  label: breadcrum-bar__wrapper;

  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: ${theme.spacings.mega};
  align-items: center;

  padding: ${theme.spacings.kilo} 0px;
`

export const Wrapper = styled('div')(wrapperStyles)

const filterButtonStyles = ({ theme }) => css`
  label: filter-button;

  background-color: ${theme.colors.white};
  box-shadow: 0px 0px 0px 1px ${theme.colors.shadow},
    0px 2px 2px 0px ${theme.colors.shadow};
`

export const FilterButton = styled(IconButton)(filterButtonStyles)
